/* eslint-disable no-param-reassign */

import Events from '../events';

class FormHandler {
  constructor(formSelector) {
    this.form = document.querySelector(formSelector);
    this.input = this.form.querySelector('input');
    this.submitBtn = this.form.querySelector('.btn');
    this.clearInputBtn = this.form.querySelector(
      '.google-search-form__clear-button',
    );

    this.attachListeners();
  }

  get searchValue() {
    return this.input.value.trim();
  }

  clearSearch() {
    return (this.input.value = '');
  }

  hideClearInputBtn() {
    this.clearInputBtn.ariaHidden = 'true';
  }

  remove() {
    this.form.remove();
  }

  enable() {
    [this.input, this.submitBtn].forEach(
      (element) => (element.disabled = false),
    );
  }

  disable() {
    [this.input, this.submitBtn].forEach(
      (element) => (element.disabled = true),
    );
  }

  attachListeners() {
    this.form.addEventListener('input', () => {
      const { searchValue } = this;
      this.clearInputBtn.ariaHidden = searchValue === '';
    });

    this.clearInputBtn.addEventListener('click', () => {
      this.clearSearch();
      this.hideClearInputBtn();
      this.input.focus();
    });

    this.form.addEventListener('submit', () => {
      window.dispatchEvent(Events.SearchSubmittedEvent);
    });
  }
}

export default FormHandler;
